import { colorFromBgColor } from '@/utils';
import { useTranslations } from 'next-intl';
import ArrowRight from '@/assets/arrowRight.svg';

type AtAGlanceTrendDurationModel = {
  trendDuration?: string;
  backgroundColour?: string;
};

const AtAGlanceTrendDuration = ({ trendDuration, backgroundColour }: AtAGlanceTrendDurationModel) => {
  const t = useTranslations();

  const isto20years = trendDuration === '0 - 20 years';

  const unit = 100 / 6;
  let percentage = unit;
  switch (trendDuration) {
    case '0 - 4 years':
      percentage = 2 * unit;
      break;
    case '3 - 6 years':
      percentage = 3 * unit;
      break;
    case '0 - 8 years':
      percentage = 4 * unit;
      break;
    case '0 - 10 years':
    case '6 - 10 years':
      percentage = 5 * unit;
      break;
    case '0 - 20 years':
      percentage = 6 * unit;
      break;
  }

  const yearScale = [2, 4, 6, 8, 10];
  const yearSmallScale = [2, 4, 6, 8, 10, 12];

  return (
    <div className="flex w-full flex-col pl-6">
      <h3 className="my-4 h-7 text-lg leading-7 font-bold">{t('report.atAGlance.$trendDuration')}</h3>
      <div className="flex flex-wrap">
        <div
          className="color-adjust-exact mb-3 h-1 w-full"
          style={{ backgroundColor: colorFromBgColor(backgroundColour, 0.1) || undefined }}
        >
          {isto20years ? (
            <div className="flex h-full">
              <div
                className="z-10 h-full w-4/5 flex-1"
                style={{
                  background: 'linear-gradient( 90deg, rgba(184, 236, 149, 1) 99.5%, rgba(184, 236, 149, 0) 100%  )',
                }}
              />
              <div className="z-20 h-full w-1/5">
                <div className="border-t-4 border-dashed" />
              </div>
            </div>
          ) : (
            <div
              className="h-full"
              style={{
                background: `linear-gradient(
                  90deg,
                  rgba(184, 236, 149, 1) ${percentage - 3}%,
                  rgba(184, 236, 149, 0) ${percentage + 5}%
                )`,
              }}
            />
          )}
        </div>
        <div className="flex w-full flex-row justify-between">
          <div className="body-1">{t('report.atAGlance.$trendDurationNow')}</div>
          {isto20years ? (
            <>
              {yearScale.map((year, index) => (
                <div className="body-1" key={index}>
                  {t('report.atAGlance.$trendDurationXYrs', { year })}
                </div>
              ))}
              <div className="arrow">
                <ArrowRight className="stroke-from-bg fill-from-bg h-[25px]" />
              </div>
              <div className="body-1">{t('report.atAGlance.$trendDurationXYrs', { year: 20 })}</div>
            </>
          ) : (
            yearSmallScale.map((year, index) => (
              <div className="body-1" key={index}>
                {t('report.atAGlance.$trendDurationXYrs', { year })}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AtAGlanceTrendDuration;
